import { render, staticRenderFns } from "./cardFaqEdit.vue?vue&type=template&id=cda9c378"
import script from "./cardFaqEdit.vue?vue&type=script&lang=js"
export * from "./cardFaqEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports